import { Box, Flex, Text } from '@fundamentals'
import { IconButton } from '@common/material'
import { ClearOutlined, EditOutlined } from '@mui/icons-material'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form'
import { useModal } from '@common/GlobalModal'
import { RegisterItemOverrideFormulaModal } from '@modules/registers/items/form/modals/RegisterItemOverrideFormulaModal'
import { localizedStrings } from '@core/strings'
import moment from 'moment/moment'
import { RegisterItemRemoveFormulaOverrideModal } from '@modules/registers/items/form/modals/RegisterItemRemoveFormulaOverrideModal'

export const RegisterPropertyFormulaOverrideActions: React.FC<
  RegisterItemPropertyFormItemProps
> = (props) => {
  const { showModal } = useModal()
  const propertyValue = props?.registerItem?.dataWithLinkProperties?.find(
    (p) => p.registerPropertyId === props.property.id,
  )

  const overrideDateString = moment(propertyValue?.formulaOverriddenOn).format(
    'Do MMM YYYY',
  )
  const overrideTimeString = moment(propertyValue?.formulaOverriddenOn).format(
    'HH:mm',
  )

  return (
    <Flex alignItems={'center'} sx={{ mt: -2 }}>
      {!!propertyValue?.formulaOverride && (
        <Box ml={2}>
          <Text fontSize={13} fontWeight={'bold'}>
            {localizedStrings.override}
          </Text>
          <Text
            fontSize={13}
          >{`${propertyValue?.formulaOverriddenBy?.firstName} ${propertyValue?.formulaOverriddenBy?.lastName}`}</Text>
          <Text fontSize={13}>
            {overrideDateString} - {overrideTimeString}
          </Text>
        </Box>
      )}
      <IconButton
        onClick={() =>
          showModal(<RegisterItemOverrideFormulaModal {...props} />)
        }
      >
        <EditOutlined />
      </IconButton>
      {!!propertyValue?.formulaOverride && (
        <IconButton
          onClick={() => {
            showModal(<RegisterItemRemoveFormulaOverrideModal {...props} />)
          }}
        >
          <ClearOutlined />
        </IconButton>
      )}
    </Flex>
  )
}
